import { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TextKey, DataTestId, RouteName } from '@mews-commander/enums';
import { IconName } from '@optimus-web/core';
import { isCurrentEnterpriseCheckoutReportEnabled } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { getSelectedServiceId } from '@mews-commander/legacy-entities/src/ducks/serviceSelect';
import DashboardTitle from '../components/DashboardTitle';
import DashboardTextLink from '../components/DashboardTextLink';
import { startServiceStatisticsPoller, resetServiceStatistics } from '../actions/serviceStatistics';
import DeparturesStatisticsChart from './DeparturesStatisticsChart';
import ArrivalsStatisticsChart from './ArrivalsStatisticsChart';

const ServiceStatistics = ({ startPoller, resetWidget, selectedServiceId, checkoutReportEnabled }: $TSFixMe) => {
    useEffect(() => {
        startPoller(selectedServiceId);
        return resetWidget;
    }, [startPoller, resetWidget, selectedServiceId]);

    return (
        <Fragment>
            <DashboardTitle testId={DataTestId.Reservations} textKey={TextKey.ReservationPlural} />
            <DashboardTextLink
                textKey={TextKey.ReservationOverview}
                iconName={IconName.ReservationPreview}
                route={RouteName.ReservationOverviewReportIndex}
                routeParams={{
                    query: {
                        'Service.Id': selectedServiceId,
                    },
                }}
            />
            <DashboardTextLink
                textKey={TextKey.ReservationReport}
                iconName={IconName.SummaryOrder}
                route={RouteName.ReservationReportIndex}
                routeParams={{
                    query: {
                        'Service.Id': selectedServiceId,
                    },
                }}
            />
            <ArrivalsStatisticsChart dataTestId={DataTestId.ArrivalsStatisticsChart} />
            <DeparturesStatisticsChart
                // @ts-expect-error $TSFixMeError: Type '{ checkoutReportEnabled: any; dataTestId: DataTestId; }' is not assignable to type 'IntrinsicAttributes & Pick<Omi...
                checkoutReportEnabled={checkoutReportEnabled}
                dataTestId={DataTestId.DeparturesStatisticsChart}
            />
        </Fragment>
    );
};

export default connect(
    createStructuredSelector({
        selectedServiceId: getSelectedServiceId,
        checkoutReportEnabled: isCurrentEnterpriseCheckoutReportEnabled,
    }),
    {
        startPoller: startServiceStatisticsPoller,
        resetWidget: resetServiceStatistics,
    }
)(ServiceStatistics);
